import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AppDownload, AppDownloadEntities, AppDownloadParam } from '../app-download.model';

export enum AppDownloadActionTypes {
  GetAppDownloads = '[AppDownload] Get AppDownloads',
  LoadAppDownloads = '[AppDownload] Load AppDownloads',
  UpdateAppDownloads = '[AppDownload] Update AppDownload',
  GetAppDownloadsFail = '[AppDownload] Get AppDownload Fail'
}

export class GetAppDownloads implements Action {
  readonly type = AppDownloadActionTypes.GetAppDownloads;
  constructor(public payload: any = null) {}
}

export class LoadAppDownloads implements Action {
  readonly type = AppDownloadActionTypes.LoadAppDownloads;
  constructor(public payload: AppDownloadEntities) {}
}

export class UpdateAppDownloads implements Action {
  readonly type = AppDownloadActionTypes.UpdateAppDownloads;
  constructor(public payload: AppDownloadParam) {}
}

export class GetAppDownloadsFail implements Action {
  readonly type = AppDownloadActionTypes.GetAppDownloadsFail;
  constructor(public payload: any = null) {}
}

export type AppDownloadActions =
  GetAppDownloads
 | LoadAppDownloads
 | UpdateAppDownloads
 | GetAppDownloadsFail;
